import './InputNumber.less'
import InputNumber from './InputNumber'
export default InputNumber
